import { CargoV2ApiRepository } from "@/app/infrastructures/repositories/api/CargoV2ApiRepository";
import { CargoV2Mapper } from "@/data/persistences/mappers/CargoV2Mapper";
import { container } from "tsyringe";
import ApiService from "@/app/infrastructures/services/ApiService";
import { CargoV2Presenter } from "@/app/ui/presenters/CargoV2Presenter";
import { CargoV2Endpoint } from "@/app/infrastructures/endpoints/CargoV2Endpoint";

export class CargoV2Component {
  public static init(): void {
    container.register<CargoV2Endpoint>(CargoV2Endpoint, {
      useClass: CargoV2Endpoint
    });
    container.register<CargoV2Mapper>(CargoV2Mapper, {
      useClass: CargoV2Mapper
    });
    container.register<CargoV2ApiRepository>(CargoV2ApiRepository, {
      useFactory: (d) =>
        new CargoV2ApiRepository(
          d.resolve(ApiService),
          d.resolve(CargoV2Mapper),
          d.resolve(CargoV2Endpoint)
        )
    });
    container.register<CargoV2Presenter>(CargoV2Presenter, {
      useFactory: (d) => new CargoV2Presenter(d.resolve(CargoV2ApiRepository))
    });
  }
}
